import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntProblemlevel: SelectDataObject[] = [
    { i: 0, t: 'Keine Probleme', icon: 'mdi:check-circle', iconColor: 'success.main' },
    { i: 1, t: 'Hinweise vorhanden', icon: 'mdi:information', iconColor: 'info.main' },
    { i: 2, t: 'Warnungen vorhanden', icon: 'mdi:alert', iconColor: 'warning.main' },
    { i: 3, t: 'Probleme vorhanden', icon: 'mdi:alert-circle', iconColor: 'error.main' },
];
export default sIntProblemlevel;
